import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { WHATSAPP_URL } from "@/config";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-void">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <p className="font-display text-3xl md:text-4xl text-bone leading-tight">
          MINDENGINE<span className="text-vermilion">.</span>
        </p>
        <p className="mt-1 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-ash">Technologies</p>
        <p className="mt-4 text-ash text-sm md:text-base leading-relaxed max-w-sm">
          One connected AI operating layer for the customer lifecycle — interaction, intelligence, and value protection.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-vermilion mb-6">Pages</p>
        <div className="flex flex-col gap-3">
          {[
            ["Home", "/"],
            ["Capabilities", "/capabilities"],
            ["Use Cases", "/use-cases"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <Link
              key={to}
              to={to}
              data-testid={`footer-link-${slug(label)}`}
              className="text-ash hover:text-bone transition-colors duration-300 text-sm w-fit"
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-vermilion mb-6">Reach us</p>
        <p className="text-ash text-sm leading-relaxed">Global — online &amp; on-site.</p>
        <div className="mt-4 flex flex-col gap-2">
          <a href="mailto:sales@aiinaa.com" data-testid="footer-email-sales" className="text-ash hover:text-bone transition-colors duration-300 text-sm w-fit">sales@aiinaa.com</a>
          <a href="mailto:ceo@aiinaa.com" data-testid="footer-email-ceo" className="text-ash hover:text-bone transition-colors duration-300 text-sm w-fit">ceo@aiinaa.com</a>
        </div>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-4 inline-flex items-center gap-2 text-bone text-sm border-b border-vermilion pb-1 hover:text-vermilion transition-colors duration-300"
        >
          Chat on WhatsApp <ArrowUpRight size={14} />
        </a>
      </div>
    </div>
    <div className="border-t border-line">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-2">
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-ash">© 2026 Mindengine Technologies — aiinaa.com</p>
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-ash">Interact · Understand · Protect Value</p>
      </div>
    </div>
  </footer>
);
